export const msalConfig = {
  auth: {
    clientId: "8cd642d9-4d4f-4de6-a82e-7f51a288a270",
    authority:
      "https://login.microsoftonline.com/05fa20a6-fcb8-498b-a6d7-c00d2b9b1c6c",
    redirectUri: `${window.location.origin}/sso-login`,
    // redirectUri: "http://localhost:4173/sso-login",
    // redirectUri: "http://localhost:3000/sso-login",
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {},
  },
};

export const loginRequest = {
  scopes: [],
};
